import { TextField as MuiTextField, TextFieldProps } from '@mui/material'

function TextField ( props: TextFieldProps ) {
    const {
        ...rest
    } = props

    return (
        <MuiTextField className="text-field-wrapper" { ...rest }/>
    )
}

export default TextField
